import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  updateEntity,
  withEntities,
} from '@ngrx/signals/entities';
import { User } from '../../../types';
const _usersEntityConfig = () =>
  entityConfig({
    collection: 'users',
    entity: type<User>(),
    selectId: (entity) => entity.id,
  });

export const withUserEntities = () => {
  return signalStoreFeature(
    withEntities(_usersEntityConfig()),
    withMethods(({ ...store }) => ({
      loadUser: (data: User[]) => {
        return patchState(store, setAllEntities(data, _usersEntityConfig()));
      },
      updateUser: (id: string, changes: User) =>
        patchState(store, updateEntity({ id, changes }, _usersEntityConfig())),
    })),
  );
};
